/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.filterable()
    export class CampaignGrid extends NoboxEntityGrid<CampaignRow, any> {
        protected getColumnsKey() { return CampaignColumns.columnsKey; }
        protected getDialogType() { return CampaignDialog; }
        protected getIdProperty() { return CampaignRow.idProperty; }
        protected getInsertPermission() { return CampaignRow.insertPermission; }
        protected getLocalTextPrefix() { return CampaignRow.localTextPrefix; }
        protected getService() { return CampaignService.baseUrl; }
        constructor(container: JQuery) {
            super(container);
            
            var q = Q.parseQueryString();
            if (q["status"]) {
                var categorySt = this.findQuickFilter(CampaignStatus,
                    CampaignRow.Fields.Status)
                categorySt.value = q["status"];
            }
            if (q["sd"] && q["ed"]) {
                var categoryCr = this.findQuickFilter(CustomDateFilter,
                    CampaignRow.Fields.In);
                if (q["sd"] == "All" || q["ed"] == "All") {
                    categoryCr.set_value(null);
                    categoryCr.end_set_value(null);
                } else {
                    categoryCr.set_value(q["sd"]);
                    categoryCr.end_set_value(q["ed"]);
                }
            }
        }

        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();
            let accounts = Q.getLookup("Nobox.AccountLookup").itemById as unknown as AccountRow[];
            let lists = Q.getLookup("Nobox.ListLookup").itemById as unknown as ListRow[];
            let channel = Q.getLookup("Nobox.ChannelNmLookup").itemById as unknown as Master.ChannelRow[];
            let dvs = Q.getLookup("NoBoxCRM.DivisionsLookup").itemById as unknown as DivisionsRow[];

            Q.first(columns, x => x.field == CampaignRow.Fields.ChannelId).format =
                ctx => `<a href="javascript:;" class="channel-link">${Q.htmlEncode(channel[ctx.value].Nm)}</a>`;
            Q.first(columns, x => x.field == CampaignRow.Fields.DvsId).format =
                ctx => `<a href="javascript:;" class="division-link">${Q.htmlEncode(Q.isEmptyOrNull(ctx.value) ? "" : dvs[ctx.value].Name)}</a>`;
            Q.first(columns, x => x.field == CampaignRow.Fields.AccountIds).format =
                ctx => {
                    if (!ctx.value)
                        return "";

                    ctx.value = ctx.value.split(",") as number[];
                    var elList = "";
                    var idLast = 0;
                    ctx.value.forEach(function (x) {
                        let g = accounts[x] as any;
                        idLast = x;
                        if (!g) {
                            elList += `<span id="${x.toString()}" class="account-link">${x.toString()}, </span>`;
                        } else {
                            elList += `<span id="${x.toString()}" class="account-link">${Q.htmlEncode(g.Name)}, </span>`;
                        }
                    });
                    if (accounts[idLast]) {
                        return `<a href="javascript:;">${elList.replace(accounts[idLast].Name + ", ", accounts[idLast].Name)}</a>`;
                    } else {
                        return `<a href="javascript:;">${idLast.toString() + ", ", idLast.toString()} </a>`;
                    }
                };
            Q.first(columns, x => x.field == CampaignRow.Fields.ListIds).format =
                ctx => {
                    let idList = ctx.value;
                    if (!idList)
                        return "";

                    idList = idList.split(",") as number[]
                    var elList = "";
                    var idLast = 0;
                    idList.forEach(function (x) {
                        let g = lists[BigInt(x)] as any;
                        idLast = x;
                        if (!g) {
                            elList += `<span id="${x.toString()}" class="list-link">${x.toString()}, </span>`;
                        } else {
                            elList += `<span id="${x.toString()}" class="list-link">${Q.htmlEncode(g.Nm)}, </span>`;
                        }
                    });
                    if (lists[BigInt(idLast)]) {
                        return `<a href="javascript:;">${elList.replace(lists[BigInt(idLast)].Nm + ", ", lists[BigInt(idLast)].Nm)}</a>`;
                    } else {
                        return `<a href="javascript:;">${elList.replace(idLast.toString() + ", ", idLast.toString())} </a>`;
                    }
                };

            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);
            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented()) {
                return;
            }

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            if (target.hasClass("list-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by list");
                var categoryFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    CampaignRow.Fields.ListIds);
                categoryFilter.set_value(categoryFilter.get_value() + "," + target.attr("id"));
                this.refresh();
            } else if (target.hasClass("account-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by account");
                var channelFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    CampaignRow.Fields.ChannelId);
                channelFilter.set_value(`${item.ChannelId}`);
                var accFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    CampaignRow.Fields.AccountIds);
                accFilter.set_value(accFilter.get_value() + "," + target.attr("id"));
                this.refresh()
            } else if (target.hasClass("tags-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by tags");
                var tagsFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    CampaignRow.Fields.Tags);
                tagsFilter.set_value(tagsFilter.get_value() + "," + target.text());
                this.refresh();
            } else if (target.hasClass("status-link")) {
                e.preventDefault();
                
                Q.notifySuccess("Success filter by status");
                var statusFilter = this.findQuickFilter(Serenity.Select2Editor,
                    CampaignRow.Fields.Status);
                statusFilter.set_value(`${item.Status}`);
                this.refresh();
            }else if (target.hasClass("channel-link")) {
                e.preventDefault();
                
                Q.notifySuccess("Success filter by channel");
                var channelFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    CampaignRow.Fields.ChannelId);
                channelFilter.set_value(`${item.ChannelId}`);
                this.refresh();
            }else if (target.hasClass("division-link")) {
                e.preventDefault();
                
                Q.notifySuccess("Success filter by division");
                var dvsFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    CampaignRow.Fields.DvsId);
                dvsFilter.set_value(`${item.DvsId}`);
                this.refresh();
            }
        }

        protected getButtons() {
            var $this = this;
            var buttons = super.getButtons();
            buttons.push({

                icon: "fa-envelope-o text-blue",
                hint: "Direct Message",
                separator: true,
                onClick: () => {
                    var dlg = new CampaignDirectDialog();
                    dlg.loadNewAndOpenDialog();
                }
            });
            return buttons;
        }
        protected getQuickFilters() {
            var flt = super.getQuickFilters();
            //this.refresh();
            var filter1 = Q.first(flt, x => x.field == CampaignRow.Fields.ListIds);
            filter1.handler = h => {
                const request = (h.request as CampaignListRequest);
                const values = (h.widget as Serenity.LookupEditor).values;
                if (h.active) {
                    request.ListIds = values.map(x => Number(x));
                    h.handled = true;
                } else {
                    request.ListIds = [];
                    h.handled = true;
                }
            };
            var filter2 = Q.first(flt, x => x.field == CampaignRow.Fields.Tags);
            filter2.handler = h => {
                const request = (h.request as CampaignListRequest);
                const values = (h.widget as Serenity.LookupEditor).values;
                if (h.active) {
                    request.Tags = values.map(x => x);
                    h.handled = true;
                } else {
                    request.Tags = [];
                    h.handled = true;
                }
            };

            var filter3 = Q.first(flt, x => x.field == CampaignRow.Fields.In);
            filter3.handler = h => {
                const request = (h.request as CampaignListRequest);
                const start = (h.widget as CustomDateFilter).get_value();
                const end = (h.widget as CustomDateFilter).end_get_value();
                if (h.active) {
                    if (start != null && end != null) {
                        request.Criteria = [[["In"], ">=", start], "and", [["In"], "<=", end]]
                    } else if (start != null) {
                        request.Criteria = [["In"], ">=", start];
                    } else if (end != null) {
                        request.Criteria = [["In"], "<=", end];
                    }
                    h.handled = true;
                } else {
                    h.handled = true;
                }
            };

            return flt;
        }

        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Serenity.ListRequest;
            //request.ColumnSelection = 1;
            return true;
        }
    }
}